import clsx from 'clsx';
import React, { memo } from 'react';
import { Typography } from '../typography';
import styles from './styles.module.css';
import { usePrice } from './use-price';
/**
 * `<Price>` - Компонент для вывода цены.
 * @example ```tsx
 <Price value={12345.67} fraction units="₽/шт" />
 * ```
 */
export const Price = /*#__PURE__*/memo(props => {
  const {
    integer,
    decimals,
    showFraction,
    integerProps,
    fractionProps,
    units
  } = usePrice(props);
  const {
    className,
    align = 'left',
    variant = 'regular',
    size = 'm',
    children,
    fraction,
    inline = false,
    ...rest
  } = props;
  const mobileClassName = {
    [styles.mobile]: variant === 'medium' && size === 'xl'
  };
  const wrapperClassName = clsx(className, styles.wrapper, styles[align], {
    [styles.inline]: inline
  });
  const fractionClassName = clsx(styles.priceFraction, mobileClassName);
  const unitClassName = clsx(styles.priceUnit, mobileClassName);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName,
    ...rest
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.price,
    "data-testid": "price"
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "price-integer",
    ...integerProps
  }, integer, showFraction && ','), showFraction && (/*#__PURE__*/React.createElement(Typography, {
    "data-testid": "price-fraction",
    className: fractionClassName,
    ...fractionProps
  }, decimals)), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "price-unit",
    className: unitClassName,
    overrideStyles: false,
    ...fractionProps
  }, units)), children);
});